<template>
  <div v-rect-loading="loading" class="policy-tos">
    <div class="header">
      <div class="title">{{ headerTitle }}</div>
    </div>
    <div class="content">
      <WrappedForm
        ref="formEditor"
        :formLines="formLines"
        :model="formData"
      >
        <template #tinyMceEditor="{ lineName}">
          <TinymceEditor v-if="showTinyMceEditor" v-model="formData[lineName]" class="policy-input"></TinymceEditor>
        </template>
      </WrappedForm>
      <div class="bottom-btn-group">
        <el-button class="cancel-btn" @click="handleBackClick">{{ $t('common.btn.cancel') }}</el-button>
        <el-button class="save-btn" @click="handleSavePolicy">{{ $t('common.btn.save') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import WrappedForm from '@/components/formEditor/wrappedForm.vue'

const POLICY_TYPE = {
  PRIVACY: 'PRIVACY',
  TOS: 'TOS'
}

export default {
  components: {
    WrappedForm,
    TinymceEditor: () => import('./tinymceEditor.vue')
  },
  data () {
    return {
      loading: false,
      i18nPrefix: 'admin.company.agreement',
      formData: {
        policyType: 'PRIVACY',
        agreementPolicyCn: null,
        agreementPolicyEn: null
      },
      showTinyMceEditor: false
    }
  },
  computed: {
    isEdit () {
      return this.$route.meta.isEditMode
    },
    disabledPolicySelect () {
      const policyId = this.$route.params.policyId
      if (policyId) {
        return true
      } else {
        return false
      }
    },
    policyTypeList () {
      const policyTypeList = _.map(POLICY_TYPE, (val, key) => {
        return {
          label: this.$t(`${this.i18nPrefix}.label.${key}`),
          value: val
        }
      })
      return policyTypeList
    },
    refForm () {
      return this.$refs.formEditor
    },
    formLines () {
      return {
        policyType: {
          elType: 'el-select',
          label: this.$t(`${this.i18nPrefix}.label.agreementCategory`),
          option: {
            data: this.policyTypeList
          },
          events: {
            change: this.handleChange
          },
          disabled: this.disabledPolicySelect
        },
        agreementPolicyCn: {
          label: this.$t(`${this.i18nPrefix}.label.agreementCnContent`),
          contentSlot: 'tinyMceEditor'
        },
        agreementPolicyEn: {
          label: this.$t(`${this.i18nPrefix}.label.agreementEnContent`),
          contentSlot: 'tinyMceEditor'
        }
      }
    },
    headerTitle () {
      const i18nPrefix = `${this.i18nPrefix}.label`
      if (this.isEdit) {
        return this.$t(`${i18nPrefix}.editAgreementTitle`)
      } else {
        return this.$t(`${i18nPrefix}.createAgreementTitle`)
      }
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions('agreement', ['getSystemPolicyById', 'saveSystemPolicy', 'updateSystemPolicy']),
    async loadData () {
      const policyId = this.$route.params.policyId
      if (policyId) {
        this.policyType = this.$route.query.type
        const params = {
          policy_id: policyId
        }
        this.loading = true
        try {
          const resp = await this.getSystemPolicyById(params)
          if (resp) {
            this.formData.agreementPolicyCn = resp.content_cn
            this.formData.agreementPolicyEn = resp.content_en
          } else {
            this.$router.push('/v-admin/system-policy-management')
          }
        } finally {
          this.loading = false
        }
      }
      this.showTinyMceEditor = true
    },
    handleChange () {
      this.formData.agreementPolicyCn = null
      this.formData.agreementPolicyEn = null
    },
    handleBackClick () {
      this.$router.push('/v-admin/system-policy-management')
    },
    async handleSavePolicy () {
      const policyId = this.$route.params.policyId
      const params = {
        content_cn: this.formData.agreementPolicyCn,
        content_en: this.formData.agreementPolicyEn
      }
      let createOrUpdateMethod = null
      let successMsg = null
      this.$eventBus.$emit('showLoading', true)
      if (policyId) {
        params.policy_id = policyId
        createOrUpdateMethod = this.updateSystemPolicy
        successMsg = this.$t(`${this.i18nPrefix}.message.updateSuccess`)
      } else {
        params.type = this.formData.policyType
        createOrUpdateMethod = this.saveSystemPolicy
        successMsg = this.$t(`${this.i18nPrefix}.message.createSuccess`)
      }
      try {
        const resp = await createOrUpdateMethod(params)
        if (resp) {
          this.$message.success(successMsg)
          this.$router.push('/v-admin/system-policy-management')
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    }
  },
  watch: {
    '$i18n.locale' () {
      this.showTinyMceEditor = false
      this.$nextTick(() => {
        this.showTinyMceEditor = true
      })
    }
  }

}

</script>

<style lang='scss' scoped>
.policy-tos {
  .header {
    border-bottom: 1px solid #e4e7ed;

    .title {
      padding-top: 4px;
      padding-bottom: 18px;
      line-height: 25px;
      font-size: 18px;
      font-weight: 500;
      color: #303133;
    }
  }

  .content {
    width: 720px;
    margin: 30px auto 0;
  }

  .bottom-btn-group {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;

    .el-button {
      padding: 8px 28px;
      border-radius: 2px;
      line-height: 22px;
      font-size: 16px;
      font-weight: 500;
      color: #0096cc;
    }

    .save-btn {
      margin-left: 24px;
      margin-right: 0;
      background: #0096cc;
      border-color: #0096cc;
      color: #ffffff;
    }
  }
}
</style>
